<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters,mapActions,mapState } from "vuex"
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import DataTable from "@/components/DataTable.vue";


/**
 * Advanced table component
 */
export default {
  page: {
    title: "Purchase Returns Report Today",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    DataTable,   
  },
  data() {
    return {
      filterTitle:'Purchase Returns Report',
      data: {
        datefrom: '',
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        product:'',
         page: 1,
        per_page: 50,
      },
      currentdate:moment(new Date()).format("YYYY-MM-DD"),
      title: "Purchase Returns Report Today",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Purchase Returns Report Today",
          active: true,
        },
      ],
      totalRows: 1,
      totals:{
        totalAmount:0
      },
   
      filteredReport:[],
      pageOptions: [10, 25, 50, 100, 200, 1000],
      IsPurchasesReturnServerPaginated: true,
      serverPerPage: 50,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product.product_name",
          sortable: true,
          label: "PRODUCT",
        },
        {
          key: "quantity",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "unit_price_no",
          sortable: true,
          label: "UNIT PRICE",
        },
        {
          key: "amount",
          sortable: true,
          label: "AMOUNT REFUNDED",
        },
        {
          key: "reason",
          sortable: true,
          label: "REASON",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "type",
          sortable: true,
          label: "TYPE",
        },
        {
          key: "user.name",
          sortable: true,
          label: "RECORDED BY",
        },
      ],
      json_fields: {
        PRODUCT_NAME: "product.product_name",
        QUANTITY: "quantity",
        UNIT_PRICE: "unit_price",
        AMOUNT_REFUNDED: "amount",
        MODE: "mode",
        REASON: "reason",
        DATE: "date",
        TYPE: "type",
        RECORDED_BY: "user.name",
        RECORDED_ON: "date_recorded",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],

    };
  },
  
  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("purchase", ["PurchasesReturn","PurchasesReturnSummary","PurchasesReturnPagination","PurchasesReturnPaginated","FilterStatus"]),
    ...mapGetters("products", ["Products"]),


    rows() {
      return this.IsPurchasesReturnServerPaginated
        ? this.PurchasesReturnPagination?.total
        : this.PurchasesReturnPaginated
        ? this.PurchasesReturnPaginated.length
        : 0;
    },

    perPage: {
      get() {
        if (this.IsPurchasesReturnServerPaginated) {
          const value =
            this.PurchasesReturnPagination?.per_page ||
            this.data.per_page ||
            this.serverPerPage;
          return parseInt(value) || this.serverPerPage;
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsPurchasesReturnServerPaginated) {
          this.data.per_page = value;
          this.data.page = 1;
          this.FetchReturns(this.data);
        }
      },
    },

    currentPage: {
      get() {
        return this.PurchasesReturnPaginated && this.PurchasesReturnPagination
          ? this.PurchasesReturnPagination.current_page
          : 1;
      },
      set(value) {
        if (this.PurchasesReturnPaginated) {
          this.data.page = value;
          this.FetchReturns(this.data);
        }
      },
    },

  },

  methods: {
    ...mapActions({
      FetchReturns: "purchase/fetchReturns",
      FetchProducts: "products/fetchProducts",

    }),
   
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    filterReport() {
       let payload = { ...this.data };

      payload.page = 1;
      if (!payload.per_page) {
        payload.per_page = this.serverPerPage;
      }
      this.FetchReturns(payload);
    },

    assiginData() {
      this.filteredReport = this.PurchasesReturn;

      let total = 0;
      this.PurchasesReturn?this.PurchasesReturn.forEach((value) => {
        let amt = parseInt(value.amount);
        total = total + amt;
      }):[];
      this.totals.totalAmount = total;
    },


    handlePageChange(newPage) {
      if (this.IsPurchasesReturnServerPaginated) {
        this.data.page = newPage;
        this.FetchReturns(this.data);
      }
    },
  },

  watch: {
    PurchasesReturn(newValue){
      if(newValue){
        this.assiginData();
      }
    },
  },

  created() {
    this.FetchReturns(this.data);
    this.FetchProducts();
    this.assiginData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center" v-html="filterTitle"></h3>
              </div>

            </div>
            <div class="row">
              <div class="col-md-3 mt-4">
                <download-excel
                  class="btn btn-info"
                  :data="filteredReport"
                  :fields="json_fields"
                  :worksheet="'PURCHASE RETUNRS REPORT ON' + currentdate"
                  type="csv"
                  :name="'Purchase_returns' + currentdate + '.xls'"
                >
                  Export Excel <i class="fa fa-download"></i>
                </download-excel>
              </div>
              <div class="col-md-3 form-group mb-2">
                <label>FROM</label>
                <input
                  @change="filterReport()"
                  type="date"
                  v-model="data.datefrom"
                  class="form-control"
                  v-limit-future-date
                />
              </div>
              <div class="col-md-3 form-group">
                <label>TO</label>
                <input
                  @change="filterReport()"
                  v-model="data.dateto"
                  type="date"
                  class="form-control"
                  v-limit-future-date
                />
              </div>
              <div class="col-2">
                <div class="form-group">
                  <label>Product</label>
                  <model-list-select
                    :list="
                    Products
                      ? [{ id: '', name: 'All Products' }, ...Products]
                      : []
                  "
                    v-model="data.product"
                    option-value="id"
                    option-text="name"
                    class="mb-3"
                    placeholder="Select Product"
                    @input="filterReport()"
                  >
                  </model-list-select>
                </div>
              </div>
              <div class="col-md-1 mt-4">
                <button
                  class="btn btn-primary cursor-pointer"
                  type="button"
                  @click="filterReport()"
                >
                  <span class="fa fa-filter cursor-pointer"></span> Filter
                  <b-spinner
                    v-show="FilterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
             
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <DataTable
                  :columns="fields"
                  :rows="PurchasesReturn || []"
                  :total-rows="rows"
                  :pagination="PurchasesReturnPagination"
                  :server-pagination="IsPurchasesReturnServerPaginated"
                  :loading="FilterStatus"   
              >
                <template #cell(index)="{ index }">
                  {{ (currentPage - 1) * perPage + index + 1 }}
                </template>
                <template #cell(product.product_name)="{row}">
                  {{ row.product.product_name }}
                </template>
                <template #cell(quantity)="{row}">
                  {{ row.quantity }}
                </template>
                <template #cell(unit_price_no)="{row}">
                  {{ thousandSeperator(row.unit_price_no) }}
                </template>

                <template #cell(amount)="{row}">
                  {{ thousandSeperator(row.amount) }}
                </template>
                <template #cell(reason)="{row}">
                  {{ row.reason }}
                </template>
                <template #cell(date)="{row}">
                  {{ row.date }}
                </template>
                <template #cell(type)="{row}">
                  {{ row.type }}
                </template>
                <template #cell(user.name)="{row}">
                  {{ row.user.name }}
                </template>
              </DataTable>
              <div class="row">
                  <div class="col-md-2"></div>
                  <div class="col-md-6">
                    <h5>Total Amount Refunded: <span class="text-danger">{{thousandSeperator(totals.totalAmount)}}</span></h5>
                  </div>
                </div>
            </div>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
